import { format } from "date-fns";
import { getStatusDisplayLabel, ZOHO_SYNC_CONFIG } from "../constant";

const formatDate = (date) =>
  date ? format(new Date(date), "MM/dd/yyyy") : "";

const formatScore = (value) => {
  if (value == null || value === "") return "";
  return Math.floor(value * 10) / 10;
};

const getZohoSyncLabel = (status) => {
  if (!status) return "Not Synced";
  return ZOHO_SYNC_CONFIG[status]?.label ?? status;
};

export const mapDashboardRowForExport = (row) => ({
  "Candidate Name": row.candidateName || "",
  "Job Title": row.jobTitle || "",
  "Interview Status": getStatusDisplayLabel(row.status) || row.status || "",
  "AI Behavior Score": formatScore(row.behaviourScore),
  "AI Response Score": formatScore(row.answereScore),
  "Scheduled Date": formatDate(row.scheduledDate) || "Not Scheduled",
  "Completed Date": formatDate(row.completedAt) || "Not Completed",
  "Zoho Sync": getZohoSyncLabel(row.zohoSyncStatus),
});

export const getDashboardExportFileName = () =>
  `candidate-interviews-${format(new Date(), "yyyy-MM-dd")}.xlsx`;
